import React from "react";

import { Box, Text, Link } from "@chakra-ui/react";

const Not_Crm_User = () => {
  return (
    <Box mt="16px" className="form-intergrate-body">
      <Text
        fontSize="14px"
        align="center"
        // mb="2"
      >
        Signup for a{" "}
        <Link
          color="#2C5CC5"
          fontWeight="600"
          href="https://www.freshworks.com/crm/signup/?plan_id=suite&utm_source=wordpress_plugin"
        >
          Freshworks CRM account{" "}
        </Link>{" "}
        to capture contacts directly to your CRM. <Text align="center">Or</Text>
        <Text align="center">Connect to your CRM by adding a webhook.</Text>
      </Text>
    </Box>
  );
};

export default Not_Crm_User;
